export default __webpack_public_path__ + "static/media/ic_avax_40.ba220dde.svg";